/* Pumpkin seed oil landing page: offer block, add to cart, sticky button. */
(function () {
  'use strict';

  var offer = document.getElementById('pso-offer');
  var sticky = document.querySelector('[data-pso-sticky]');

  // Show the sticky button only after she has read a quarter of the page (so a cold visitor can't skip
  // straight to the price), and hide it while the offer block is on screen.
  if (sticky) {
    var hero = document.querySelector('.pso-media');
    var pastHero = false;
    var READ_GATE_PCT = 25;
    // The bar only shows while she is at least a quarter of the way down the page. It goes away again
    // if she scrolls back above that point, and nothing is remembered across a refresh.
    var readEnough = false;
    var offerVisible = false;
    var buyBtn = offer && offer.querySelector('[data-pso-add]');
    var stickyLink = sticky.querySelector('[data-pso-sticky-link]');
    var stickyBuy = sticky.querySelector('[data-pso-sticky-buy]');
    var buyVisible = false;
    var update = function () {
      // Inside the offer the bar disappears: it never turns into a checkout button, so a second
      // tap in the same spot can't send her to checkout before she has read the offer.
      if (stickyLink) stickyLink.hidden = false;
      if (stickyBuy) stickyBuy.hidden = true;
      sticky.classList.toggle('is-hidden', !readEnough || buyVisible || offerVisible);
    };
    if (stickyBuy && buyBtn) stickyBuy.addEventListener('click', function () { buyBtn.click(); });
    var onGateScroll = function () {
      var doc = document.documentElement;
      var max = Math.max(1, doc.scrollHeight - window.innerHeight);
      var pct = (window.pageYOffset || doc.scrollTop || 0) / max * 100;
      var now = pct >= READ_GATE_PCT;
      if (now !== readEnough) {
        readEnough = now;
        update();
      }
    };
    window.addEventListener('scroll', onGateScroll, { passive: true });
    window.addEventListener('pageshow', onGateScroll);
    onGateScroll();
    if (buyBtn && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        buyVisible = entries[0].isIntersecting;
        update();
      }).observe(buyBtn);
    }
    if ('IntersectionObserver' in window) {
      if (hero) {
        new IntersectionObserver(function (entries) {
          pastHero = !entries[0].isIntersecting && entries[0].boundingClientRect.top < 0;
          update();
        }).observe(hero);
      } else {
        pastHero = true;
      }
      if (offer) {
        new IntersectionObserver(function (entries) {
          offerVisible = entries[0].isIntersecting;
          update();
        }, { rootMargin: '0px 0px -20% 0px' }).observe(offer);
      }
      update();
    } else {
      sticky.classList.remove('is-hidden');
    }
  }

  // Desktop side card: same rule as the mobile bar. It shows only while she is at least a quarter of
  // the way down the page, goes away if she scrolls back above that, and hides at the offer.
  var rail = document.querySelector('[data-pso-rail]');
  if (rail) {
    var RAIL_GATE_PCT = 25;
    var offerEl = document.getElementById('pso-offer');
    var revealed = false;
    var atOffer = false;
    var paintRail = function () {
      var on = revealed && !atOffer;
      rail.hidden = false;
      rail.classList.toggle('is-on', on);
      rail.setAttribute('aria-hidden', on ? 'false' : 'true');
    };
    var onRailScroll = function () {
      var doc = document.documentElement;
      var max = Math.max(1, doc.scrollHeight - window.innerHeight);
      var now = (window.pageYOffset || doc.scrollTop || 0) / max * 100 >= RAIL_GATE_PCT;
      if (now !== revealed) {
        revealed = now;
        paintRail();
      }
    };
    window.addEventListener('scroll', onRailScroll, { passive: true });
    window.addEventListener('pageshow', onRailScroll);
    onRailScroll();
    if (offerEl && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        atOffer = entries[0].isIntersecting;
        paintRail();
      }, { rootMargin: '0px 0px -30% 0px' }).observe(offerEl);
    }
  }

  // Looping videos (the bladder animation): load them just before they come on screen, and play them
  // whenever they are actually in view. Phones often refuse to start a video that is still off screen,
  // so we ask again once it is visible, and once more on her first touch if the phone blocked it
  // (for example in Low Power Mode).
  var lazyVideos = document.querySelectorAll('video.pso-lazyvideo[data-src]');
  if (lazyVideos.length) {
    var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var loadVideo = function (v) {
      if (v.getAttribute('src')) return;
      v.muted = true;
      v.defaultMuted = true;
      v.setAttribute('muted', '');
      v.setAttribute('playsinline', '');
      v.setAttribute('webkit-playsinline', '');
      var hls = v.dataset.hls;
      v.src = hls && v.canPlayType('application/vnd.apple.mpegurl') ? hls : v.dataset.src;
      v.load();
    };
    var playVideo = function (v) {
      if (reduceMotion) return;
      loadVideo(v);
      if (!v.paused) return;
      var p = v.play();
      if (p && p.catch) p.catch(function () {});
    };
    var inView = function (v) {
      var r = v.getBoundingClientRect();
      return r.bottom > 0 && r.top < window.innerHeight;
    };
    if ('IntersectionObserver' in window) {
      var nearIo = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { loadVideo(e.target); nearIo.unobserve(e.target); }
        });
      }, { rootMargin: '1200px 0px' });
      var seenIo = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) {
            var v = e.target;
            playVideo(v);
            v.addEventListener('canplay', function () { if (inView(v)) playVideo(v); }, { once: true });
          }
        });
      }, { threshold: 0.15 });
      lazyVideos.forEach(function (v) { nearIo.observe(v); seenIo.observe(v); });
    } else {
      lazyVideos.forEach(playVideo);
    }
    var playVisible = function () {
      lazyVideos.forEach(function (v) { if (inView(v)) playVideo(v); });
    };
    ['touchend', 'click'].forEach(function (evt) {
      document.addEventListener(evt, playVisible, { passive: true });
    });
    window.addEventListener('pageshow', playVisible);
  }

  // Testimonial video: buffer it before she reaches it, then tap to play with sound.
  var loadTestimonial = function (v) {
    if (!v || v.src) return;
    var hls = v.dataset.hls;
    v.preload = 'auto';
    v.src = hls && v.canPlayType('application/vnd.apple.mpegurl') ? hls : v.dataset.src;
    try { v.load(); } catch (e) { /* older browsers */ }
  };
  var tvids = document.querySelectorAll('video.pso-tvideo__video[data-src]');
  if (tvids.length && 'IntersectionObserver' in window) {
    var tio = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { loadTestimonial(e.target); tio.unobserve(e.target); }
      });
    }, { rootMargin: '900px 0px' });
    tvids.forEach(function (v) { tio.observe(v); });
  }
  document.querySelectorAll('[data-pso-tplay]').forEach(function (btn) {
    var tv = btn.parentNode.querySelector('video');
    if (tv) {
      tv.addEventListener('play', function () { btn.hidden = true; btn.style.display = 'none'; });
    }
    btn.addEventListener('click', function () {
      var v = btn.parentNode.querySelector('video');
      if (!v) return;
      loadTestimonial(v);
      v.muted = false;
      v.controls = true;
      btn.hidden = true;
      btn.style.display = 'none';
      var p = v.play();
      if (p && p.catch) p.catch(function () { btn.hidden = false; btn.style.display = ''; });
    });
  });

  // Reviews carousel: arrows + dots for a swipeable row.
  document.querySelectorAll('[data-pso-reviews]').forEach(function (wrap) {
    var track = wrap.querySelector('[data-pso-rtrack]');
    var dots = wrap.querySelectorAll('[data-pso-rdots] span');
    if (!track) return;
    var cards = track.children;
    var current = function () {
      var best = 0;
      var bestDist = Infinity;
      for (var k = 0; k < cards.length; k++) {
        var d = Math.abs(cards[k].offsetLeft - cards[0].offsetLeft - track.scrollLeft);
        if (d < bestDist) { bestDist = d; best = k; }
      }
      return best;
    };
    var updateDots = function () {
      var i = current();
      dots.forEach(function (d, k) { d.classList.toggle('is-on', k === i); });
    };
    var step = function (dir) {
      if (!cards.length) return;
      var i = Math.max(0, Math.min(cards.length - 1, current() + dir));
      var target = cards[i].offsetLeft - cards[0].offsetLeft;
      var start = track.scrollLeft;
      track.scrollTo({ left: target, behavior: 'smooth' });
      // Some browsers ignore smooth scrolling with snap points; jump directly if nothing moved.
      setTimeout(function () {
        if (Math.abs(track.scrollLeft - start) < 4 && Math.abs(target - start) >= 4) track.scrollLeft = target;
        updateDots();
      }, 350);
      setTimeout(updateDots, 700);
    };
    var prev = wrap.querySelector('[data-pso-rprev]');
    var next = wrap.querySelector('[data-pso-rnext]');
    if (prev) prev.addEventListener('click', function () { step(-1); });
    if (next) next.addEventListener('click', function () { step(1); });
    var scrollTimer;
    track.addEventListener('scroll', function () {
      clearTimeout(scrollTimer);
      scrollTimer = setTimeout(updateDots, 60);
    }, { passive: true });
  });

  // Product photos open large when tapped, and a second tap zooms in so the label can be read.
  (function () {
    var photos = Array.prototype.slice.call(document.querySelectorAll('.pso-gallery__slide img'));
    if (!photos.length) return;
    var big = function (img) {
      var src = img.currentSrc || img.src || '';
      return src.replace(/([?&])width=\d+/, '$1width=2000');
    };
    var box = document.createElement('div');
    box.className = 'pso-zoom';
    box.hidden = true;
    box.setAttribute('role', 'dialog');
    box.setAttribute('aria-modal', 'true');
    box.setAttribute('aria-label', 'Product photo');
    box.innerHTML = '<button type="button" class="pso-zoom__close" aria-label="Close photo">&times;</button>' +
      '<button type="button" class="pso-zoom__nav pso-zoom__nav--prev" aria-label="Previous photo">&#8249;</button>' +
      '<button type="button" class="pso-zoom__nav pso-zoom__nav--next" aria-label="Next photo">&#8250;</button>' +
      '<div class="pso-zoom__pane"><img class="pso-zoom__img" alt=""></div>' +
      '<p class="pso-zoom__hint">Tap the photo to zoom in</p>';
    document.body.appendChild(box);
    var pane = box.querySelector('.pso-zoom__pane');
    var image = box.querySelector('.pso-zoom__img');
    var hint = box.querySelector('.pso-zoom__hint');
    var current = 0;
    var lastFocus = null;
    var show = function (i) {
      current = (i + photos.length) % photos.length;
      box.classList.remove('is-zoomed');
      hint.textContent = 'Tap the photo to zoom in';
      image.src = big(photos[current]);
      image.alt = photos[current].alt || '';
      pane.scrollTop = 0;
      pane.scrollLeft = 0;
    };
    var open = function (i) {
      lastFocus = document.activeElement;
      show(i);
      box.hidden = false;
      document.documentElement.classList.add('pso-zoom-open');
      box.querySelector('.pso-zoom__close').focus();
      if (typeof window.psoTrack === 'function') {
        window.psoTrack('Sleep Page CTA Click', { cta: 'Zoom photo ' + (i + 1), area: 'Photo gallery', href: '' });
      }
    };
    var close = function () {
      box.hidden = true;
      document.documentElement.classList.remove('pso-zoom-open');
      image.removeAttribute('src');
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    };
    photos.forEach(function (img, i) {
      img.classList.add('pso-zoomable');
      img.addEventListener('click', function () { open(i); });
    });
    image.addEventListener('click', function (e) {
      var zoomed = box.classList.toggle('is-zoomed');
      hint.textContent = zoomed ? 'Drag to look around. Tap again to zoom out' : 'Tap the photo to zoom in';
      if (zoomed) {
        var r = pane.getBoundingClientRect();
        var fx = (e.clientX - r.left) / Math.max(1, r.width);
        var fy = (e.clientY - r.top) / Math.max(1, r.height);
        requestAnimationFrame(function () {
          pane.scrollLeft = (pane.scrollWidth - pane.clientWidth) * fx;
          pane.scrollTop = (pane.scrollHeight - pane.clientHeight) * fy;
        });
      }
    });
    box.querySelector('.pso-zoom__close').addEventListener('click', close);
    box.querySelector('.pso-zoom__nav--prev').addEventListener('click', function () { show(current - 1); });
    box.querySelector('.pso-zoom__nav--next').addEventListener('click', function () { show(current + 1); });
    box.addEventListener('click', function (e) { if (e.target === box || e.target === pane) close(); });
    document.addEventListener('keydown', function (e) {
      if (box.hidden) return;
      if (e.key === 'Escape') close();
      if (e.key === 'ArrowLeft') show(current - 1);
      if (e.key === 'ArrowRight') show(current + 1);
    });
  })();

  // Product gallery: swipe + thumbnails.
  document.querySelectorAll('[data-pso-gallery]').forEach(function (g) {
    var track = g.querySelector('[data-pso-gtrack]');
    var thumbs = g.querySelectorAll('[data-pso-gthumb]');
    if (!track) return;
    var slides = track.children;
    var setActive = function (i) { thumbs.forEach(function (t, k) { t.classList.toggle('is-on', k === i); }); };
    var index = function () { return Math.round(track.scrollLeft / Math.max(1, track.clientWidth)); };
    thumbs.forEach(function (t) {
      t.addEventListener('click', function () {
        var i = Number(t.dataset.psoGthumb);
        if (!slides[i]) return;
        var target = slides[i].offsetLeft - slides[0].offsetLeft;
        track.scrollTo({ left: target, behavior: 'smooth' });
        setTimeout(function () { if (Math.abs(track.scrollLeft - target) > 4) track.scrollLeft = target; setActive(index()); }, 350);
        setActive(i);
      });
    });
    var go = function (i) {
      if (!slides.length) return;
      i = (i + slides.length) % slides.length;
      var target = slides[i].offsetLeft - slides[0].offsetLeft;
      track.scrollTo({ left: target, behavior: 'smooth' });
      // Some browsers ignore smooth scrolling with snap points; jump directly if nothing moved.
      setTimeout(function () { if (Math.abs(track.scrollLeft - target) > 4) track.scrollLeft = target; setActive(index()); }, 350);
      setActive(i);
    };
    var gPrev = g.querySelector('[data-pso-gprev]');
    var gNext = g.querySelector('[data-pso-gnext]');
    if (gPrev) gPrev.addEventListener('click', function () { go(index() - 1); });
    if (gNext) gNext.addEventListener('click', function () { go(index() + 1); });
    var gt;
    track.addEventListener('scroll', function () { clearTimeout(gt); gt = setTimeout(function () { setActive(index()); }, 60); }, { passive: true });
  });

  // Delivery date: today + N days in her own time zone, e.g. "Tuesday, Oct 6".
  document.querySelectorAll('[data-pso-date]').forEach(function (el) {
    var days = Number(el.dataset.days) || 7;
    var d = new Date();
    d.setDate(d.getDate() + days);
    try {
      el.textContent = d.toLocaleDateString('en-US', { weekday: 'long', month: 'short', day: 'numeric' });
    } catch (e) { /* keep the server-rendered date */ }
  });

  if (!offer) return;

  var form = offer.querySelector('[data-pso-form]');
  var subToggle = offer.querySelector('[data-pso-sub]');
  var button = offer.querySelector('[data-pso-add]');
  var errorBox = offer.querySelector('[data-pso-error]');
  var money = window.Intl ? new Intl.NumberFormat('en-US', { style: 'currency', currency: offer.dataset.currency || 'USD' }) : null;

  function formatCents(cents) {
    var n = Number(cents) / 100;
    return money ? money.format(n) : '$' + n.toFixed(2);
  }

  function selectedBundle() {
    return form.querySelector('input[name="pso-bundle"]:checked');
  }

  // Prices: subscription (default) or one-time, savings vs single bottles, and the button price.
  var btnPrice = offer.querySelector('[data-pso-btnprice]');
  var stickyPrice = document.querySelector('[data-pso-sticky-price]');
  var saveLabel = form.dataset.saveLabel || 'You save';
  var payTotal = offer.querySelector('[data-pso-total]');

  // Show the visitor's own US state in the reassurance line ("Ships free to Texas").
  // Falls back to the generic wording if the lookup fails or she is outside the US.
  var visitorState = '';
  var assure = offer.querySelector('[data-pso-assure]');
  function applyState(name) {
    visitorState = name || '';
    if (assure && visitorState && assure.dataset.template) {
      assure.textContent = assure.dataset.template.replace('[state]', visitorState);
    }
  }
  try {
    var savedState = sessionStorage.getItem('psoState');
    if (savedState !== null) {
      applyState(savedState);
    } else if (window.fetch) {
      fetch('https://get.geojs.io/v1/ip/geo.json')
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (g) {
          var name = g && g.country_code === 'US' && g.region ? String(g.region) : '';
          try { sessionStorage.setItem('psoState', name); } catch (e) {}
          applyState(name);
        })
        .catch(function () {});
    }
  } catch (e) {}
  var subSave = offer.querySelector('[data-pso-subsave]');
  var subGift = offer.querySelector('[data-pso-subgift]');
  var subText = offer.querySelector('[data-pso-subtext]');
  function renderPrices() {
    var useSub = subToggle && subToggle.checked;
    form.querySelectorAll('input[name="pso-bundle"]').forEach(function (input) {
      var label = input.closest('.pso-bundle');
      var price = Number(useSub && input.dataset.subPrice ? input.dataset.subPrice : input.dataset.price);
      var ref = Number(input.dataset.ref || 0);
      if (!price) return;
      var bottles = Number(input.dataset.bottles) || 1;
      var unitEl = label.querySelector('[data-pso-unit]');
      if (unitEl) unitEl.textContent = formatCents(Math.floor(price / bottles));
      var priceEl = label.querySelector('[data-pso-price]');
      var wasEl = label.querySelector('[data-pso-was]');
      var saveEl = label.querySelector('[data-pso-save]');
      if (priceEl) priceEl.textContent = formatCents(price);
      if (wasEl) wasEl.textContent = ref > price ? formatCents(ref) : '';
      if (saveEl) saveEl.textContent = ref > price ? saveLabel + ' ' + Math.floor((1 - price / ref) * 100 + 0.001) + '%' : '';
      // Buttons show the per-bottle price; the total appears at checkout.
      var perBottle = ' | ' + formatCents(Math.floor(price / bottles)) + (form.dataset.perBottle || '/bottle');
      if (input.checked && btnPrice) btnPrice.textContent = perBottle;
      if (input.checked && stickyPrice) stickyPrice.textContent = perBottle;
      if (input.checked && payTotal) {
        payTotal.textContent = (payTotal.dataset.label || '') + ' ' + formatCents(price) + (payTotal.dataset.suffix ? ' ' + payTotal.dataset.suffix : '');
      }
      // Free gifts come with the refill plan only: greyed with the condition until the box is ticked.
      var giftEl = label.querySelector('[data-pso-gift]');
      var giftName = input.dataset.giftName || '';
      if (giftEl && giftName) {
        var giftText = giftEl.querySelector('[data-pso-gift-text]');
        var giftTpl = (useSub ? offer.dataset.giftOn : offer.dataset.giftLocked) || '';
        if (giftText && giftTpl) giftText.textContent = giftTpl.replace('[gift]', giftName);
        giftEl.classList.toggle('is-on', !!useSub);
      }
      if (input.checked && subGift) {
        subGift.textContent = giftName ? (subGift.dataset.tpl || '').replace('[gift]', giftName) : '';
        var subGiftWrap = subGift.closest('[data-pso-subgift-wrap]') || subGift;
        subGiftWrap.hidden = !giftName;
      }
      if (input.checked && subText) {
        var subTpl = subText.dataset.tpl || '';
        var subAmt = Number(input.dataset.subPrice || 0);
        subText.textContent = subTpl
          .replace('[bottles]', bottles + (bottles === 1 ? ' bottle' : ' bottles'))
          .replace('[cadence]', input.dataset.ship || 'every month')
          .replace('[price]', subAmt ? formatCents(subAmt) : '');
      }
      if (input.checked && subSave) {
        var once = Number(input.dataset.price || 0), sub = Number(input.dataset.subPrice || 0);
        subSave.textContent = sub && once > sub
          ? (subSave.dataset.prefix || 'Save') + ' ' + formatCents(once - sub) + ' ' + (subSave.dataset.suffix || '')
          : '';
      }
    });
  }
  form.querySelectorAll('input[name="pso-bundle"]').forEach(function (input) {
    input.addEventListener('change', renderPrices);
  });
  if (subToggle) subToggle.addEventListener('change', renderPrices);
  renderPrices();

  // If she comes back from checkout with the back button, the page is restored as she left it,
  // with the button still switched off. Switch every checkout button back on.
  window.addEventListener('pageshow', function () {
    document.querySelectorAll('[data-pso-add], [data-pso-sticky-buy]').forEach(function (b) {
      if (b.hasAttribute('aria-busy') || b.dataset.psoLocked) {
        b.disabled = false;
        b.removeAttribute('aria-busy');
      }
    });
    renderPrices();
  });

  function post(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body || {})
    }).then(function (r) {
      if (!r.ok) return r.json().then(function (j) { throw new Error(j.description || j.message || 'Could not add to cart'); });
      return r.json();
    });
  }

  function resetCartCookies() {
    ['cart', 'cart_sig', 'cart_ts', 'cart_currency'].forEach(function (name) {
      var expired = name + '=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/';
      document.cookie = expired;
      document.cookie = expired + '; domain=.' + location.hostname.replace(/^www\./, '');
    });
  }

  function showError(msg) {
    if (!errorBox) return;
    errorBox.textContent = msg;
    errorBox.hidden = false;
  }

  if (!button) return;

  // Mini cart: on when the section setting is ticked, or for a preview with ?cart=1.
  var cartMode = offer.dataset.cart === 'on' || /[?&]cart=1\b/.test(location.search);

  button.addEventListener('click', function () {
    var bundle = selectedBundle();
    if (!bundle || !bundle.dataset.variant) {
      showError(form.dataset.errorChoose || 'Please choose a supply above.');
      return;
    }
    if (errorBox) errorBox.hidden = true;
    goToCheckout(bundle);
  });

  function goToCheckout(bundle) {
    button.disabled = true;
    button.setAttribute('aria-busy', 'true');

    var item = { id: Number(bundle.dataset.variant), quantity: Number(bundle.dataset.qty || 1) };
    if (subToggle && subToggle.checked && bundle.dataset.plan) item.selling_plan = Number(bundle.dataset.plan);
    // Reassurance shown under the product in the cart and at checkout.
    var shipBtn = offer.querySelector('[data-ship-from]');
    var shipFrom = shipBtn ? shipBtn.getAttribute('data-ship-from') : '';
    if (shipFrom) item.properties = { 'Shipping': shipFrom.replace('[state]', visitorState || 'the USA'), 'Guarantee': '90-day money-back' };
    // On the refill plan, spell out the schedule so it shows under the product at checkout.
    if (item.selling_plan) {
      var refillBottles = Number(bundle.dataset.bottles) || 1;
      item.properties = item.properties || {};
      item.properties['Refills'] = refillBottles + (refillBottles === 1 ? ' bottle ' : ' bottles ') + (bundle.dataset.ship || 'every month') +
        (bundle.dataset.subPrice ? ' at ' + formatCents(Number(bundle.dataset.subPrice)) : '') + '. Cancel anytime.';
    }
    var items = [item];
    // Free gifts are added only when she has ticked the refill plan.
    var onPlan = !!item.selling_plan;
    if (onPlan && bundle.dataset.gift && offer.dataset.giftVariant) {
      items.push({ id: Number(offer.dataset.giftVariant), quantity: 1, properties: { _gift: 'yes' } });
    }
    if (onPlan && bundle.dataset.guide && offer.dataset.guideVariant) {
      var guideProps = { _gift: 'yes' };
      if (offer.dataset.guideUrl) guideProps['Read your guide'] = offer.dataset.guideUrl;
      items.push({ id: Number(offer.dataset.guideVariant), quantity: 1, properties: guideProps });
    }

    // Replace whatever is in the cart so the order is exactly the chosen bundle.
    // If an old saved cart rejects the items, start a fresh cart and try once more.
    var addItems = function () { return post('/cart/add.js', { items: items }); };
    post('/cart/clear.js')
      .then(addItems)
      .catch(function () {
        resetCartCookies();
        return addItems();
      })
      .then(function () {
        var price = Number((subToggle && subToggle.checked && bundle.dataset.subPrice) || bundle.dataset.price || 0) / 100;
        var useCart = cartMode && window.psoCart;
        if (typeof window.fbq === 'function') {
          window.fbq('track', 'AddToCart', { content_ids: [String(item.id)], content_type: 'product', value: price, currency: offer.dataset.currency || 'USD' });
          // With the mini cart, InitiateCheckout fires from the cart's Secure checkout button instead.
          if (!useCart) window.fbq('track', 'InitiateCheckout', { value: price, currency: offer.dataset.currency || 'USD', num_items: 1 });
        }
        // Save which Meta ad she came from on the order (shows under "Additional details").
        var attrs = typeof window.psoAttribution === 'function' ? window.psoAttribution() : {};
        var go = useCart
          ? function () { button.disabled = false; button.removeAttribute('aria-busy'); window.psoCart.open(); }
          : function () { window.location.href = '/checkout'; };
        if (Object.keys(attrs).length) {
          return post('/cart/update.js', { attributes: attrs }).then(go, go);
        }
        go();
      })
      .catch(function (err) {
        console.error('[pso] add to cart failed', err);
        showError(form.dataset.errorGeneral || 'Sorry, something went wrong. Please try again.');
        button.disabled = false;
        button.removeAttribute('aria-busy');
      });
  }
})();

/* Offer urgency: live countdown to the real launch deadline + personal outcome dates. Shown only inside the offer box. */
(function () {
  var fmt = function (d) { return d.toLocaleDateString('en-US', { month: 'long', day: 'numeric' }); };
  var pad = function (n) { return (n < 10 ? '0' : '') + n; };
  document.querySelectorAll('[data-pso-deadline]').forEach(function (el) {
    var end = new Date(el.getAttribute('data-pso-deadline') + 'T23:59:59-04:00').getTime();
    if (isNaN(end)) return;
    var u = {}; el.querySelectorAll('[data-u]').forEach(function (b) { u[b.getAttribute('data-u')] = b; });
    var tick = function () {
      var left = Math.floor((end - Date.now()) / 1000);
      if (left <= 0) { el.hidden = true; clearInterval(timer); return; }
      u.d.textContent = Math.floor(left / 86400);
      u.h.textContent = pad(Math.floor(left % 86400 / 3600));
      u.m.textContent = pad(Math.floor(left % 3600 / 60));
      u.s.textContent = pad(left % 60);
      el.hidden = false;
    };
    var timer = setInterval(tick, 1000); tick();
  });
  document.querySelectorAll('[data-pso-startdate]').forEach(function (el) {
    var ship = Number(el.getAttribute('data-ship-days')) || 7;
    var start = Date.now() + ship * 86400000;
    var w6 = new Date(start + 42 * 86400000), w12 = new Date(start + 84 * 86400000);
    var month6 = w6.toLocaleDateString('en-US', { month: 'long' });
    el.innerHTML = (el.getAttribute('data-tpl') || '').replace('[month6]', '<strong>' + month6 + '</strong>').replace('[week6]', '<strong>' + fmt(w6) + '</strong>').replace('[week12]', '<strong>' + fmt(w12) + '</strong>');
    el.hidden = false;
  });
})();

// Free sleep guide sign-up for readers who aren't ready to order (Klaviyo client API).
(function () {
  var box = document.querySelector('[data-pso-lead]');
  if (!box) return;
  var form = box.querySelector('[data-pso-lead-form]');
  var btn = box.querySelector('[data-pso-lead-btn]');
  var err = box.querySelector('[data-pso-lead-err]');
  var done = box.querySelector('[data-pso-lead-done]');
  var company = box.getAttribute('data-company');
  var list = box.getAttribute('data-list');
  var guide = box.getAttribute('data-guide') || '/pages/sleep-guide';
  function post(path, payload) {
    return fetch('https://a.klaviyo.com/client/' + path + '/?company_id=' + encodeURIComponent(company), {
      method: 'POST',
      headers: { 'Content-Type': 'application/vnd.api+json', revision: '2025-07-15' },
      body: JSON.stringify(payload)
    }).then(function (res) { if (!res.ok) throw new Error('Klaviyo ' + path + ' ' + res.status); return res; });
  }
  form.addEventListener('submit', function (e) {
    e.preventDefault();
    err.hidden = true;
    var email = (form.email.value || '').trim();
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) { err.textContent = email ? 'Please check your email address.' : 'Type your email above, then tap the button.'; err.hidden = false; form.email.focus(); return; }
    var label = btn.textContent;
    btn.disabled = true; btn.textContent = 'Sending...';
    var attribution = typeof window.psoAttribution === 'function' ? window.psoAttribution() : {};
    var props = { sleep_guide_requested_at: new Date().toISOString(), sleep_guide_page: location.pathname };
    Object.keys(attribution).forEach(function (k) { props['guide_' + k] = attribution[k]; });
    post('profiles', { data: { type: 'profile', attributes: { email: email, properties: props } } })
      .then(function () {
        return post('subscriptions', { data: { type: 'subscription', attributes: {
          custom_source: 'PSO sleep guide (not ready today)',
          profile: { data: { type: 'profile', attributes: { email: email, subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } } } } }
        }, relationships: { list: { data: { type: 'list', id: list } } } } });
      })
      .then(function () {
        form.hidden = true;
        box.querySelector('.pso-lead__fine').hidden = true;
        done.innerHTML = '';
        done.appendChild(document.createTextNode((done.getAttribute('data-tpl') || 'Thank you! Your guide is on its way.') + ' '));
        var a = document.createElement('a'); a.href = guide; a.target = '_blank'; a.rel = 'noopener'; a.textContent = 'Open it now \u2192';
        done.appendChild(a);
        done.hidden = false;
        if (typeof window.psoTrack === 'function') window.psoTrack('Sleep Page CTA Click', { cta: 'Sleep guide sign-up', area: 'Guide sign-up', href: '' });
      })
      .catch(function () {
        btn.disabled = false; btn.textContent = label;
        err.textContent = 'Something went wrong. Please try again.'; err.hidden = false;
      });
  });
})();
